import React from 'react'

function DepartmentSubTeamTabs ({
  tabs,
  activeKey,
  onChange,
}) {
  if (!tabs?.length) return null

  return (
    <div className="department-sub-team-tabs" role="tablist" aria-label="Подкоманды">
      {tabs.map((tab) => {
        const active = tab.key === activeKey
        return (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={active}
            className={`department-sub-team-tab${active ? ' department-sub-team-tab-active' : ''}`}
            onClick={() => onChange(tab.key)}
          >
            <span className="department-sub-team-tab-code">{tab.label}</span>
          </button>
        )
      })}
    </div>
  )
}

export default DepartmentSubTeamTabs
